import './BlockAccordion.scss';
class BlockAccordion {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;
        let button = t.node.querySelector('.BlockAccordion__button');
        let wrapper = t.node.querySelector('.BlockAccordion__wrapper');
        button.addEventListener('click', () => {
            if( button.getAttribute('aria-expanded') == 'false' ) {
                wrapper.setAttribute( 'aria-hidden', 'false' );
                button.setAttribute( 'aria-expanded', 'true' );
                button.setAttribute( 'aria-label', button.getAttribute('data-label-close') );
            } else {
                wrapper.setAttribute( 'aria-hidden', 'true' );
                button.setAttribute( 'aria-expanded', 'false' );
                button.setAttribute( 'aria-label', button.getAttribute('data-label-open') );
            }
        });
    }
}
JSModules['BlockAccordion'] = BlockAccordion;
export default BlockAccordion;